{
  "create": {
    "button_text": "Créer une note",
    "button_text_compact": "+ Note",
    "aria_label": "Créer une note"
  },
  "form": {
    "header": "Note",
    "placeholder": "Laissez une note ici",
    "validation_required": "Veuillez saisir une note",
    "contact_label": "Contact"
  },
  "access": {
    "manage_access": "Gérer l'accès",
    "firm_wide": "Entreprise",
    "private": "Privé"
  },
  "update": {
    "created_by": "Créé par {{name}}",
    "last_updated_by": "Dernière mise à jour par {{name}}"
  },
  "display": {
    "private_label": "Privé",
    "no_date_found": "Aucune date trouvée",
    "edit_aria_label": "modifier la note",
    "archive_aria_label": "archiver la note"
  },
  "archive": {
    "confirm_title": "Êtes-vous sûr de vouloir archiver cette note?"
  }
}
